// extracted by mini-css-extract-plugin
module.exports = {"container":"__--oversea_container__NHXIL"};